/**
 * What the UI shows for any 500 response, whatever the server body said. The server never sends raw
 * error details to clients, and the UI must not surface them either (GFG-427).
 */
export const GENERIC_SERVER_ERROR_MESSAGE =
  "Something went wrong. Please try again or contact support.";
